import { Link } from 'react-router-dom';

const AUDIENCE_FOOTER_LINKS = [
  { to: '/use-cases/conferences', label: 'Конференции' },
  { to: '/use-cases/presentations', label: 'Презентации и доклады' },
  { to: '/use-cases/timer-event-production', label: 'Продакшн-команды' },
  { to: '/use-cases/meeting-timer', label: 'Совещания и планёрки' },
  { to: '/use-cases/online-timer-for-education', label: 'Уроки и занятия' },
  { to: '/use-cases/stream-timer', label: 'Стримы и трансляции' },
  { to: '/use-cases/broadcast-timer', label: 'Эфир и вещание' },
  { to: '/use-cases/workout-timer', label: 'Тренировки и фитнес' },
  { to: '/use-cases/trade-show-timer', label: 'Выставки и экспо' },
  { to: '/use-cases/webinar-timer', label: 'Вебинары и онлайн-мероприятия' },
  { to: '/use-cases/church-timer', label: 'Церковь и служения' },
  { to: '/#for-whom-corporate', label: 'Корпоративные ивенты' },
] as const;

const MATERIALS_FOOTER_LINKS = [
  { to: '/guides', label: 'Все руководства' },
  { to: '/guides/timer-dlya-konferentsii', label: 'Таймер для конференции' },
  { to: '/guides/kak-kontrolirovat-tajming', label: 'Контроль тайминга в эфире' },
  { to: '/compare/preztimer-vs-stagetimer', label: 'Сравнение со Stagetimer' },
] as const;

const DOCUMENTS_FOOTER_ITEMS = [
  'Контакты',
  'Статус сервиса',
  'Условия использования',
  'Политика конфиденциальности',
  'Куки-файлы',
  'О сервисе',
] as const;

/** Общий футер маркетинговых страниц (лендинг, возможности, цены, changelog). */
export function MarketingFooter() {
  return (
    <footer className="cf-footer">
      <div className="cf-footer-inner">
        <div className="cf-footer-grid">
        <div>
          <div className="cf-brand">preztimer</div>
          <p className="cf-footer-about">
            Таймер выступлений в браузере. Сервис контроля времени и координации спикеров на мероприятиях.
          </p>
        </div>
        <div className="cf-footer-col-product">
          <h2>Продукт</h2>
          <p>
            <Link to="/features" className="cf-footer-link">
              Возможности
            </Link>
          </p>
          <p>
            <Link to="/pricing" className="cf-footer-link">
              Цены
            </Link>
          </p>
          <p>
            <Link to="/changelog" className="cf-footer-link">
              Что нового
            </Link>
          </p>
        </div>
        <div className="cf-footer-col-resources">
          <h2>Ресурсы</h2>
          <p>
            <Link to="/docs" className="cf-footer-link">
              Документация
            </Link>
          </p>
          <p>
            <Link to="/faq" className="cf-footer-link">
              Частые вопросы
            </Link>
          </p>
          <p>
            <Link to="/features" className="cf-footer-link">
              Решения
            </Link>
          </p>
        </div>
        <div className="cf-footer-col-for-whom">
          <h2>Для кого</h2>
          {AUDIENCE_FOOTER_LINKS.map(({ to, label }) => (
            <p key={to}>
              <Link to={to} className="cf-footer-link">
                {label}
              </Link>
            </p>
          ))}
        </div>
        <div className="cf-footer-col-materials">
          <h2>Материалы</h2>
          {MATERIALS_FOOTER_LINKS.map(({ to, label }) => (
            <p key={to}>
              <Link to={to} className="cf-footer-link">
                {label}
              </Link>
            </p>
          ))}
        </div>
        </div>
        <nav className="cf-footer-documents" aria-label="Документы">
          <ul className="cf-footer-documents-list">
            {DOCUMENTS_FOOTER_ITEMS.map((label) => (
              <li key={label}>
                <span className="cf-footer-documents-item">{label}</span>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </footer>
  );
}
